import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CertificateService {
  constructor(private readonly http: HttpClient) {}

  getCourseCertificatePdf(courseId: number): Observable<Blob> {
    return this.http.get(`api/cert/coursePDF/${courseId}`, { responseType: 'blob' });
  }

  getModuleCertificatePdf(moduleId: number): Observable<Blob> {
    return this.http.get(`api/cert/modulePDF/${moduleId}`, { responseType: 'blob' });
  }
}
